import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'list-container',
  templateUrl: './list-container.template.html',
  styleUrls: ['./list-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListContainer extends StaticContainer {
  ngOnChanges(changeRecord){
    
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/list-container/list-container.component.ts